import React, { FC, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { popupStatus } from '@/constants/popup'
import useStore from '@/store/useStore'
import { getMainHomePath } from '@/utils/route'

export const EmptyScreen: FC = () => {
  const navigate = useNavigate()
  const mediaVideo = useStore((state) => state.common.mediaVideo)
  const currentEvent = useStore((state) => state.common.currentEvent)
  const isEventOpen = Boolean(currentEvent)
  const { pagePopupStatus } = useStore((state) => state.popup)

  useEffect(() => {
    if (!mediaVideo && !isEventOpen && pagePopupStatus === popupStatus.CLOSED) {
      navigate(getMainHomePath())
    }
  }, [mediaVideo, isEventOpen, pagePopupStatus])

  return <div></div>
}
